import React, { useState } from 'react';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import { Film, Star, Calendar, Users } from 'lucide-react';
import styles from './MalayalamMoviePosters.module.css';
import Image1 from '../../images/film-poster-1.jpg'
import Image5 from '../../images/film-poster-5.jpg'
import Image7 from '../../images/film-poster-7.jpg'
import Image9 from '../../images/film-poster-9.jpg'
import Image11 from '../../images/film-poster-11.jpg'
import Image12 from '../../images/film-poster-12.jpg'
import Image16 from '../../images/film-poster-16.jpg'
import Image17 from '../../images/film-poster-17.jpg'
import Image20 from '../../images/film-poster-20.jpg'
import Image24 from '../../images/film-poster-24.jpg'
import Image25 from '../../images/film-poster-25.jpg'
import Image29 from '../../images/film-poster-29.jpg'
import Image33 from '../../images/film-poster-33.jpg'
import Image39 from '../../images/film-poster-39.jpg'
import Image41 from '../../images/film-poster-41.jpg'
import Image46 from '../../images/film-poster-46.jpg'

const MalayalamMoviePosters = () => {
  const [selectedPoster, setSelectedPoster] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);

  const moviePosters = [
    {
    id: 1,
    title: "Identity",
    year: "2025",
    genre: "Action Thriller",
    director: "Akhil Paul, Anas Khan",
    cast: "Tovino Thomas, Trisha Krishnan",
    description:
      "A sketch artist and a police officer team up to identify a mysterious killer using an eyewitness’s remembered facial details.",
    image: Image1,
  },
  {
    id: 5,
    title: "Ponman",
    year: "2025",
    genre: "Drama",
    director: "Jothish Shankar",
    cast: "Basil Joseph, Lijomol Jose, Sajin Gopu",
    description:
      "A gold dealer lends sovereigns for a village wedding but faces deadly danger when the bride’s criminal husband plans to steal the gold and eliminate him.",
    image: Image5,
  },
  {
    id: 7,
    title: "Narayaneente Moonnaanmakkal",
    year: "2025",
    genre: "Family Drama",
    director: "Sharan Venugopal",
    cast: "Alencier Ley Lopez, Joju George",
    description:
      "Three estranged brothers reunite at their ancestral home to bid farewell to their dying mother, but buried memories soon reignite old conflicts.",
    image: Image7,
  },
  {
    id: 9,
    title: "Daveed",
    year: "2025",
    genre: "Sports Drama",
    director: "Govind Vishnu",
    cast: "Antony Varghese",
    description:
      "A former boxer turned bouncer is forced back into the ring after a clash with a Turkish star, facing the fight of his life.",
    image: Image9,
  },
  {
  id: 11,
  title: "Officer On Duty",
  year: "2025",
  genre: "Action Thriller",
  director: "Jithu Ashraf",
  cast: "Kunchacko Boban, Priyamani, Vishak Nair, Jagadish",
  description:
    "A demoted police officer’s investigation into a seemingly small case uncovers a dangerous criminal conspiracy, leading to intense action and suspense.", 
  image: Image11,
},
{
  id: 12,
  title: "Get Set Baby",
  year: "2025",
  genre: "Comedy Drama/Romance",
  director: "Vinay Govind",
  cast: "Unni Mukundan, Nikhila Vimal, Shyam Mohan, Chemban Vinod Jose",
  description:
    "A male gynecologist navigates career challenges and personal relationships, finding love and purpose while working in a female-dominated field.", 
  image: Image12,
},
{
  id: 16,
  title: "Jimkhana",
  year: "2025",
  genre: "Comedy",
  director: "Khalid Rahman",
  cast: "Naslen, Lukman Avaran",
  description:
    "A lighthearted comedy where friends enter a sports competition with unexpected outcomes and camaraderie.", 
  image: Image16,
},
{
  id: 17,
  title: "Maranamass",
  year: "2025",
  genre: "Psychological Black Comedy",
  director: "Sivaprasad",
  cast: "Basil Joseph, Anishma Anilkumar, Babu Antony",
  description:
    "A dark comedy that blends psychological twists with absurdity as characters face life’s unpredictable turns.", 
  image: Image17,
},
{
  id: 20,
  title: "Sarkeet",
  year: "2025",
  genre: "Drama",
  director: "Mahesh Narayanan",
  cast: "Fahadh Faasil, Parvathy Thiruvothu",
  description:
    "A character-driven drama focusing on personal crisis, ethical dilemmas, and emotional struggles within modern life.",
  image: Image20,
},
{
  id: 24,
  title: "Narivetta",
  year: "2025",
  genre: "Drama",
  director: "Kannan Thamarakkulam",
  cast: "Tovino Thomas, Samyuktha Menon",
  description:
    "A young police officer confronts power struggles and justice while navigating threats and community conflicts.", 
  image: Image24,
},
{
  id: 25,
  title: "Detective Ujjwalan",
  year: "2025",
  genre: "Crime Thriller",
  director: "Rahul G., Indraneel G. K.",
  cast: "Dhyan Sreenivasan",
  description:
    "A clever local detective must outsmart a mysterious figure through sharp instincts and unexpected reveals.", 
  image: Image25,
},
{
  id: 29,
  title: "Vyasanasametham Bandhumithradhikal",
  year: "2025",
  genre: "Drama",
  director: "Vipin Das",
  cast: "Sreenath Bhasi",
  description:
    "A social drama exploring deep emotional ties, personal vices, and the impact of relationships on life.", 
  image: Image29,
},
{
  id: 33,
  title: "Thalavara",
  year: "2025",
  genre: "Political Drama",
  director: "Martin Prakkat",
  cast: "Indrajith Sukumaran",
  description:
    "A politically charged drama delving into power struggles, ideology, and the moral costs of leadership.", 
  image: Image33,
},
{
  id: 39,
  title: "Balti",
  year: "2025",
  genre: "Sports Drama",
  director: "Sai Abhyankkar",
  cast: "Shane Nigam",
  description:
    "A gritty sports drama following a kabaddi player’s struggles, victories and personal growth in the competitive world of athletics.", 
  image: Image39,
},
  {
  id: 41,
  title: "Theatre: The Myth of Reality",
  year: "2025",
  genre: "Action Drama",
  director: "Sajin Baabu",
  cast: "Rima Kallingal, Meenakshi Raveendran, Dain Davis, Pramod Veliyanadu, Sarasa Balussery, Balaji Sharma",
  description:
    "Drama actioner exploring myth and reality rooted in Kerala cultural narratives.", 
  image: Image41,
},
{
  id: 46,
  title: "Eko",
  year: "2025",
  genre: "Mystery Thriller",
  director: "Dinjith Ayyathan",
  cast: "Sandeep Pradeep, Vineeth, Narain, Binu Pappu, Biana Momin, Ashokan",
  description:
    "Final chapter of the Animal Trilogy — a mystery thriller unraveling secrets in misty hill terrain.", 
  image: Image46,
}


  ];

  return (
    <>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      
      <div className={styles.pageContainer}>
        <div className={styles.heroSection}>
          <div className={styles.heroContent}>
            <div className={styles.badge}>
              <Film size={20} />
              <span>Malayalam Cinema 2025</span>
            </div>
            <h1 className={styles.heroTitle}>Movie Poster Designs</h1>
            <p className={styles.heroSubtitle}>
              Conceptual poster designs for upcoming Malayalam movies in 2025, 
              showcasing creative visual storytelling and cinematic aesthetics.
            </p>
          </div>
        </div>

        <div className={styles.postersGrid}>
          {moviePosters.map((movie) => (
            <div 
              key={movie.id} 
              className={styles.posterCard}
              onClick={() => setSelectedPoster(movie)}
            >
              <div className={styles.posterImageWrapper}>
                <img src={movie.image} alt={movie.title} className={styles.posterImage} />
                <div className={styles.posterOverlay}>
                  <div className={styles.posterInfo}>
                    <h3 className={styles.posterTitle}>{movie.title}</h3>
                    <div className={styles.posterMeta}>
                      <span className={styles.posterYear}>
                        <Calendar size={14} />
                        {movie.year}
                      </span>
                      <span className={styles.posterGenre}>{movie.genre}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {selectedPoster && (
          <div className={styles.modal} onClick={() => setSelectedPoster(null)}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <button 
                className={styles.closeButton}
                onClick={() => setSelectedPoster(null)}
              >
                ×
              </button>
              
              <div className={styles.modalGrid}>
                <div className={styles.modalImageWrapper}>
                  <img 
                    src={selectedPoster.image} 
                    alt={selectedPoster.title}
                    className={styles.modalImage}
                  />
                </div>
                
                <div className={styles.modalDetails}>
                  <h2 className={styles.modalTitle}>{selectedPoster.title}</h2>
                  
                  <div className={styles.modalMeta}>
                    <div className={styles.metaItem}>
                      <Calendar size={16} />
                      <span>{selectedPoster.year}</span>
                    </div>
                    <div className={styles.metaItem}>
                      <Star size={16} />
                      <span>{selectedPoster.genre}</span>
                    </div>
                    <div className={styles.metaItem}>
                      <Film size={16} />
                      <span>Dir: {selectedPoster.director}</span>
                    </div>
                    <div className={styles.metaItem}>
                      <Users size={16} />
                      <span>{selectedPoster.cast}</span>
                    </div>
                  </div>
                  
                  <p className={styles.modalDescription}>
                    {selectedPoster.description}
                  </p>
                  
                  <div className={styles.designNote}>
                    <h4>Design Concept</h4>
                    <p>This poster design captures the essence of {selectedPoster.title} through 
                    carefully chosen typography, color palette, and visual elements that reflect 
                    the movie's genre and emotional tone.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      
      <Footer mode={mode} background="illustrations" />
    </>
  );
};

export default MalayalamMoviePosters;